import {configureStore} from '@reduxjs/toolkit'

import account from '~/reducers/account'
import deviceInfo from '~/reducers/deviceInfo'
import global from '~/reducers/global'

export const createStore = (state?) =>
  configureStore({
    reducer: {
      global,
      deviceInfo,
      account,
    },
    preloadedState: state,
  })
// @ts-ignore
export type StoreType = ReturnType<typeof createStore>

export type RootState = ReturnType<StoreType['getState']>
export type AppDispatch = StoreType['dispatch']
